<template>
  <div class="min-h-screen">
    <Header />
    
    <!-- 登录页面 -->
    <section class="min-h-screen flex items-center justify-center px-4 pt-16">
      <div class="max-w-md w-full">
        <div class="card">
          <!-- Logo和标题 -->
          <div class="text-center mb-8">
            <div class="mb-6 flex justify-center">
              <div class="relative h-12 w-[135px] flex-shrink-0">
                <img src="/logo.svg" alt="MAGIC Logo" class="h-12 w-auto absolute inset-0 transition-opacity duration-300 dark:opacity-0">
                <img src="/logo-white.svg" alt="MAGIC Logo" class="h-12 w-auto absolute inset-0 transition-opacity duration-300 opacity-0 dark:opacity-100">
              </div>
            </div>
            <h1 class="text-2xl font-bold mb-2 gradient-text">欢迎回来</h1>
            <p class="text-gray-700 dark:text-dark-muted">登录到MAGIC管理后台</p>
          </div>
          
          <!-- 登录表单 -->
          <form @submit.prevent="handleLogin" class="space-y-6">
            <div>
              <label class="block text-sm font-medium text-dark-text mb-2">邮箱地址</label>
              <input 
                v-model="email"
                type="email" 
                required
                placeholder="your@email.com"
                class="w-full px-4 py-3 dark:bg-dark-bg border border-dark-border rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent transition-all dark:text-dark-text placeholder-dark-muted"
              >
            </div>
            
            <div>
              <label class="block text-sm font-medium text-dark-text mb-2">密码</label>
              <input 
                v-model="password"
                type="password" 
                required
                placeholder="••••••••"
                class="w-full px-4 py-3 dark:bg-dark-bg border border-dark-border rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent transition-all dark:text-dark-text placeholder-dark-muted"
              >
            </div>
            
            <div class="flex items-center justify-between">
              <label class="flex items-center">
                <input type="checkbox" class="w-4 h-4 text-primary border-dark-border rounded focus:ring-primary">
                <span class="ml-2 text-sm text-gray-700 dark:text-dark-muted">记住我</span>
              </label>
              <a href="#" class="text-sm text-primary hover:text-primary-700">忘记密码?</a>
            </div>
            
            <button 
              type="submit"
              :disabled="isLoading"
              class="w-full btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <span v-if="isLoading">登录中...</span>
              <span v-else>登录</span>
            </button>
          </form>
          
          <!-- 分隔线 -->
          <div class="my-6 flex items-center">
            <div class="flex-1 border-t border-dark-border"></div>
            <span class="px-4 text-sm text-gray-700 dark:text-dark-muted">或</span>
            <div class="flex-1 border-t border-dark-border"></div>
          </div>
          
          <!-- 提示信息 -->
          <div class="text-center">
            <p class="text-gray-700 dark:text-dark-muted text-sm mb-4">没有账号?</p>
            <button 
              @click="handleGetAccount"
              class="text-primary font-medium hover:text-primary-700 transition-colors duration-300"
            >
              联系管理员获取账号
            </button>
          </div>
        </div>
        
        <!-- 底部链接 -->
        <div class="mt-8 text-center">
          <NuxtLink to="/" class="text-gray-700 dark:text-dark-muted hover:text-dark-text transition-colors duration-300 text-sm">
            ← 返回首页
          </NuxtLink>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script setup>
import { ref } from 'vue'

const email = ref('')
const password = ref('')
const isLoading = ref(false)

const handleLogin = async () => {
  isLoading.value = true
  
  // 模拟登录请求
  setTimeout(() => {
    isLoading.value = false
    alert('登录功能演示 - 这只是前端展示，实际登录功能需要后端支持')
  }, 1000)
}

const handleGetAccount = () => {
  // 触发mailto动作
  const subject = encodeURIComponent('申请PetA平台账号')
  const body = encodeURIComponent('您好，\n\n我希望申请MAGIC平台的账号。\n\n请告知需要提供哪些信息。\n\n谢谢！')
  window.location.href = `mailto:contact@magic.com?subject=${subject}&body=${body}`
}

// 设置页面meta
useHead({
  title: '登录 - MAGIC',
  meta: [
    { name: 'description', content: '登录到MAGIC数字营销平台' }
  ]
})
</script>